import { domAnimation, LazyMotion } from '@eversports/react-components/design-tokens/motion'
import PreserveQueryParam from '@eversports/react-components/logical/PreserveQueryParam'
import { Helmet } from 'react-helmet-async'

import CartCreationHandler from '../data/CartCreationHandler'
import InitialDataLoader from '../data/InitialDataLoader'
import OrderAbortHandler from '../data/OrderAbortHandler'
import OrderCreationHandler from '../data/OrderCreationHandler'

import EnsureLoggedInUser from './EnsureLoggedInUser'
import ErrorBoundary from './ErrorBoundary'
import Layout from './Layout'
import { RedirectToBrandedAppHandler } from './RedirectToBrandedAppHandler'

const App = () => (
  <>
    <Helmet>
      <title>Checkout - Eversports</title>
      <meta name="robots" content="noindex" />
    </Helmet>
    <PreserveQueryParam
      preserveParam={[
        'origin',
        'venueId',
        'redirectApp',
        'redirectPath',
        '_gl',
        'redirectToBrandedAppUri',
        'hideEversportsBranding',
      ]}
    />
    <ErrorBoundary>
      <RedirectToBrandedAppHandler>
        <EnsureLoggedInUser>
          <CartCreationHandler>
            <OrderAbortHandler>
              <OrderCreationHandler>
                <InitialDataLoader>
                  <LazyMotion features={domAnimation}>
                    <Layout />
                  </LazyMotion>
                </InitialDataLoader>
              </OrderCreationHandler>
            </OrderAbortHandler>
          </CartCreationHandler>
        </EnsureLoggedInUser>
      </RedirectToBrandedAppHandler>
    </ErrorBoundary>
  </>
)

export default App
